import VuorotJaVapaatPage from './VuorotJaVapaatPage'

export default VuorotJaVapaatPage
